import { type TicketRequest } from '@dfg/brahma-types';
import {
  CREATE_TICKET_API_URL,
  CREATE_TICKET_SERVER_API_URL,
  POST
} from './constants';

/**
 * Logs an API error by POSTing to the ticket-creation API.
 * Fire-and-forget: callers should use `void logAutomatedError(...)`.
 * Catches all errors silently to prevent recursive logging.
 */
export async function logAutomatedError(payload: TicketRequest): Promise<void> {
  try {
    if (process.env.NEXT_PUBLIC_ENV_NAME === 'local') return;
    const apiUrl =
      typeof window !== 'undefined'
        ? CREATE_TICKET_API_URL
        : CREATE_TICKET_SERVER_API_URL;
    const { screenshot: _screenshot, ...rest } = payload;
    await fetch(apiUrl, {
      method: POST,
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(rest)
    });
  } catch {
    // Silently swallow all exceptions to prevent recursive error logging
  }
}
